export const pack = {
  'pack-tile__aside': {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: '45px',
  
    height: 'auto',
    width: '100%',
    paddingBottom: '85%',
  
    overflow: 'hidden',
  },
  'pack-tile__overlay': {
    display: 'none',
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    bgColor: 'rgba(0, 0, 0, 0.75)',
  }
};
